import React, { forwardRef, useMemo } from "react";
import { Input as BaseInput } from "@mui/base/Input";
import { styled } from "@mui/system";
import { Box, TextField, Typography } from "@mui/material";
import { handleTextFieldChange } from "../../utils/utils";
import { blue, grey } from "./CutomColor";

const Input = forwardRef(function CustomInput(
  props: React.InputHTMLAttributes<HTMLInputElement> & {
    width: string;
    height: string;
    disabled: boolean;
  },
  ref: React.ForwardedRef<HTMLDivElement>
) {
  const { width, height, disabled, ...other } = props;

  return (
    // <BaseInput
    //   slots={{
    //     input: (inputProps) => (
    //       <InputElement {...inputProps} width={width} disabled={disabled} />
    //     ),
    //   }}
    //   {...props}
    //   ref={ref}
    // />
    <BaseInput
      slots={{ input: InputElement }}
      slotProps={{
        input: {
          width, // 여기에서 width를 slotProps로 전달
          height,
          disabled, // disabled도 추가
        },
      }}
      {...other}
      ref={ref}
    />
  );
});

interface CustomInputProps {
  required: boolean;
  subTitle?: string;
  setValue: React.Dispatch<React.SetStateAction<string>>;
  value: string;
  disabled?: boolean;
  width?: string;
  height?: string;
}

export default function CustomInput({
  required,
  subTitle,
  setValue,
  value,
  disabled,
  width,
  height,
}: CustomInputProps) {
  return (
    <Box>
      {subTitle && (
        <Typography sx={{ color: "var(--text-secondary-color)", mb: "3px" }}>
          {subTitle}
        </Typography>
      )}
      <Input
        required={required}
        value={value}
        disabled={disabled!}
        onChange={handleTextFieldChange(setValue)}
        width={width!}
        height={height!}
      />
    </Box>
  );
}

const InputElement = styled("input")<{
  width: string;
  height?: string;
  disabled: boolean;
}>(
  ({ theme, width, disabled, height }) => `
  min-width: ${width};
  height: ${height ?? "52px"};
  font-family: 'IBM Plex Sans', sans-serif;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  padding: 8px 12px;
  border-radius: 8px;
  color: var(--textfield-text);
  background: var(--textfield-bg);
  border: 1px solid var(--textfield-border);
  box-shadow: 0px 2px 4px ${
    theme.palette.mode === "dark" ? "rgba(0, 0, 0, 0.5)" : "rgba(0, 0, 0, 0.05)"
  };

  &:hover {
    border-color: var(--textfield-border-hover);
  }

  &:focus {
    border-color: var(--textfield-border-focused);
    box-shadow: 0 0 0 3px var(--textfield-border-focused);
  }

  &:focus-visible {
    outline: 0;
  }

  ${
    disabled
      ? `
    background: var(--textfield-disabled-bg, #f5f5f5);
    color: var(--textfield-disabled-text, #9e9e9e);
    cursor: not-allowed;
    border-color: var(--textfield-disabled-border, #ddd);
    box-shadow: none;
  `
      : ""
  }
`
);
